import api from '@/helpers/api';

const API_READ = `/api/campaign/`;
const API_UPDATE = API_READ;
const API_CREATE = API_READ;
const API_DELETE = API_READ;

export default {
  namespaced: true,
  state: {
    status: '',
    campaigns: [],
    currUser: {},
    errMessage: '',
    meta: {
      page: 1,
      limit: 10,
      total: 1,
    },
    filter: {},
    search: {},
    foundCampaigns: []
  },
  mutations: {
    request(state) {
      state.status = 'loading';
    },
    success(state) {
      state.status = 'success';
    },
    error(state) {
      state.status = 'error';
    },
    read(state, { campaigns, meta }) {
      state.campaigns = [...campaigns];
      state.meta = { ...meta };
    },
    read_single_success(state, { campaigns }) {
      state.campaigns = campaigns;
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta };
    },
    add_filter(state, { filter }) {
      state.filter = { ...filter };
    },
    set_search(state, { search }) {
      state.search = { ...search };
    },
    clear_search(state) {
      state.search = {};
    },
    setFoundCampaigns(state, foundCampaigns) {
      state.foundCampaigns = foundCampaigns;
    },
    addFoundCampaign(state, campaign) {
      state.foundCampaigns.push(campaign);
    },
  },
  actions: {
    read({ commit, state }) {
      commit('request');
      const { meta, search } = state;

      return new Promise((resolve, reject) => {
        api.request('get', API_READ, { meta, search })
          .then((result) => {
            commit('read', {
              campaigns: result.data.data,
              meta: result.data.meta,
            });
            commit('success');
            resolve();
          })
          .catch((err) => {
            commit('error', { message: err });
            reject(err);
          });
      });
    },
    read_single({ commit }, id) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('get', `${API_READ}${id}`)
          .then((result) => {
            commit('success');
            return resolve(result.data.data);
          })
          .catch((err) => {
            commit('error', { message: err });
            return reject(err);
          });
      });
    },
    delete({ commit, dispatch, state }, id) {
      commit('request');

      // Check if this is the last item on current page (before delete)
      const itemsCount = state.campaigns.length;
      const currentPage = state.meta.page;
      const willBeEmpty = itemsCount === 1 && currentPage > 1;

      return new Promise((resolve, reject) => {
        api
          .request('delete', `${API_DELETE}${id}`)
          .then((response) => {
            // If page will be empty after delete, navigate to previous page first
            if (willBeEmpty) {
              const newMeta = { ...state.meta, page: currentPage - 1 };
              commit('switch_page', { meta: newMeta });
            }

            // Reload data
            dispatch('read');
            commit('success');
            return resolve(response.data);
          })
          .catch((err) => {
            commit('error', { message: err });
            return reject(err.response.data);
          });
      });
    },
    update({ commit }, { data }) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('put', `${API_UPDATE}${data.id}`, {}, data)
          .then((request) => {
            commit('success');
            return resolve(request);
          })
          .catch((err) => {
            commit('error', { message: err });
            return reject(err);
          });
      });
    },
    create({ commit }, { data }) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('post', API_CREATE, {}, data)
          .then((request) => {
            commit('success');
            return resolve(request);
          })
          .catch((err) => {
            commit('error', { message: err });
            return reject(err);
          });
      });
    },
    generate({ commit }) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('post', `${API_CREATE}generate`, {}, {})
          .then((response) => {
            commit('success');
            return resolve(response);
          })
          .catch((err) => {
            commit('error', { message: err });
            return reject(err);
          });
      });
    },

    checkIfCampaignExists({ state }, campaignUnique) {
      const found = state.foundCampaigns.includes(campaignUnique);
      return found;
    },

    addCampaignToFound({ commit }, campaignUnique) {
      commit('addFoundCampaign', campaignUnique);
    },

    detachMembers({ commit }, campaignId) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('post', `${API_READ}${campaignId}/detach-members`, {}, {})
          .then((response) => {
            commit('success');
            return resolve(response.data);
          })
          .catch((err) => {
            commit('error', { message: err });
            return reject(err);
          });
      });
    },

    reassignMembers({ commit }, { fromCampaignId, toCampaignId }) {
      commit('request');
      return new Promise((resolve, reject) => {
        api
          .request('post', `${API_READ}${fromCampaignId}/reassign-members`, {}, { target_campaign_id: toCampaignId })
          .then((response) => {
            commit('success');
            return resolve(response.data);
          })
          .catch((err) => {
            commit('error', { message: err });
            return reject(err);
          });
      });
    },
  },
  getters: {
    campaigns: (state) => state.campaigns,
  },
};
